import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetItemTreeListNode  {
    _originalTypeClassName = "zERP.BO.BudgetItemTreeListNode";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetItemTreeListNode.translate = translateService;
}
this.children = [];
this.label = null;
this.expanded = false;
this.info = null;
this.key = null;
this.budgetItemId = null;
this.BudgetItemTreeListNodeKey = null;
this._key = this.BudgetItemTreeListNodeKey = 0; 
}

static translate: TranslateService;
_key: any;
label:any;
expanded:any;
info:any;
key:any;
budgetItemId:any;
parent:any;
children:any;
data:any;
private _BudgetItemTreeListNodeKey:any;
get BudgetItemTreeListNodeKey(): any {
    return this._BudgetItemTreeListNodeKey;
  }
set BudgetItemTreeListNodeKey(value: any) {
    this._BudgetItemTreeListNodeKey = value;
    this._key = value;
  }
static setparent = ($this, value) => {
var oldValue = $this.parent;
$this.parent = value;
if (value != null) {
if (oldValue != null) {
Domain.BudgetItemTreeListNode.removechildren(oldValue, $this);
}
Domain.BudgetItemTreeListNode.addchildren(value, $this);
}
}
static setchildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.children == null) $this.children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.children.length > 0) {
                    Domain.BudgetItemTreeListNode.removechildren($this, $this.children[0]);
                }

                Domain.BudgetItemTreeListNode.addManychildren($this, copyItems);
            }
static addManychildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetItemTreeListNode.addchildren($this, items[i]);
                }
            }
static addchildren = ($this, item) => {
                if ($this.children == null) $this.children = [];
                if (item == null || $this.children.indexOf(item) > -1) return;
                $this.children.push(item);
if (item.parent != $this) {
Domain.BudgetItemTreeListNode.setparent(item, $this);
}
}
static addRangechildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetItemTreeListNode.addchildren($this, item));
            }
static removechildren = ($this, item) => {
                if ($this == null || $this.children == null || $this.children.indexOf(item) === -1) return;
                var _index = $this.children.indexOf(item);
                $this.children.splice(_index, 1);
item.parent = null;
}
static clearchildren = ($this) => { $this.children = null; }
static setdata = ($this, value) => {
var oldValue = $this.data;
$this.data = value;
if (value != null) {
}
}

static ToBudgetItemTreeListNode(budgetDetail: any): any{let node = new Domain.BudgetItemTreeListNode();
let isExpense = budgetDetail?.IsExpense;
node.budgetItemId = budgetDetail?.BudgetItem?.Id;
node.expanded = false;
Domain.BudgetItemTreeListNode.setdata(node, new Domain.BudgetItemTreeListRowData());
node.data.Name = budgetDetail?.BudgetItem?.FullName;
node.data.InitialAmount = 0;
node.data.TemporaryAmount = 0;
node.data.Name = node?.data?.Name + " - " + Joove.Common.safeNumber(budgetDetail?.Id);
node.data.InitialApprovedAmount = budgetDetail?.InitialApprovedAmount;
node.data.AdjustmentsAmount = budgetDetail?.AdjustmentsAmount;
node.data.TotalBudgetAmount = budgetDetail?.TotalBudgetAmount;
node.data.ReservedAmount = budgetDetail?.ReservedAmount;
node.data.RemainingBudgetAmount = budgetDetail?.RemainingBudgetAmount;
node.data.InvoicedAmount = budgetDetail?.InvoicedAmount;
node.data.RemainingReservedAmount = budgetDetail?.RemainingReservedAmount;
node.data.PaymentOrderedAmount = budgetDetail?.PaymentOrderedAmount;
node.data.RemainingInvoicedAmount = budgetDetail?.RemainingInvoicedAmount;
node.data.PaidAmount = budgetDetail?.PaidAmount;
node.data.RemainingPaymentOrderdAmount = budgetDetail?.RemainingPaymentOrderdAmount;
node.data.IncomeApprovedAmount = budgetDetail?.IncomeApprovedAmount;
node.data.ReceivedAmount = budgetDetail?.ReceivedAmount;
node.data.IncomeSettledAmount = budgetDetail?.IncomeSettledAmount;
node.data.InitialAmount = budgetDetail?.InitialAmount;
node.data.TemporaryAmount = budgetDetail?.TemporaryAmount;
node.data.AmountLastYear = budgetDetail?.AmountLastYear;
node.data.Amount2YearBefore = budgetDetail?.Amount2YearBefore;
if (isExpense) {node.data.Progress = (CLMS.Framework.Number.GreaterThan(() => budgetDetail.TotalBudgetAmount, () => 0) ? Joove.Common.mathRound(Joove.Common.safeNumber((Joove.Common.safeNumber(budgetDetail?.ReservedAmount) / Joove.Common.safeNumber(budgetDetail?.TotalBudgetAmount))) * Joove.Common.safeNumber(100), 2) : 0);}else {node.data.Progress = (CLMS.Framework.Number.GreaterThan(() => budgetDetail.TotalBudgetAmount, () => 0) ? Joove.Common.mathRound(Joove.Common.safeNumber((Joove.Common.safeNumber(budgetDetail?.ReceivedAmount) / Joove.Common.safeNumber(budgetDetail?.TotalBudgetAmount))) * Joove.Common.safeNumber(100), 2) : 0);}
return node;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BudgetItemTreeListNodeKey == null || $this.BudgetItemTreeListNodeKey == 0;
            }


}